
import useDidomi from '@/composables/didomi/useDidomi'

export default () => {
  const { locale } = useI18n()

  const {
    isSameLanguage,
    setDidomiLanguage,
    refresh,
    show,
  } = useDidomi()

  const footerData = [
    {
      label: 'navigation.first.aboutBS',
      children: [
        {
          label: 'navigation.second.group.label',
          link: 'navigation.second.group.link',
        },
        {
          label: 'navigation.second.authorities.label',
          link: 'navigation.second.authorities.link',
        },
        {
          label: 'navigation.second.cooperation.label',
          link: 'navigation.second.cooperation.link',
        },
        {
          label: 'navigation.second.esg.label',
          link: 'navigation.second.esg.link',
        },
        {
          label: 'navigation.second.foundation.label',
          link: 'navigation.second.foundation.link',
          external: true,
        },
        {
          label: 'navigation.second.press.label',
          link: 'navigation.second.press.link',
          external: true,
        },
        {
          label: 'navigation.second.abroad.label',
          link: 'navigation.second.abroad.link',
          external: false,
        },
        {
          label: 'navigation.second.career.label',
          link: 'navigation.second.career.link',
        },
      ],
    },
    {
      label: 'navigation.first.products',
      children: [
        {
          label: 'navigation.second.multisport.label',
          link: 'navigation.second.multisport.link',
        },
        {
          label: 'navigation.second.multilife.label',
          link: 'navigation.second.multilife.link',
        },
        {
          label: 'navigation.second.multibilet.label',
          link: 'navigation.second.multibilet.link',
        },
        {
          label: 'navigation.second.multiteatr.label',
          link: 'navigation.second.multiteatr.link',
        },
        {
          label: 'navigation.second.myBenefit.label',
          link: 'navigation.second.myBenefit.link',
        },
        {
          label: 'navigation.first.wellbeingScore.label',
          link: 'navigation.first.wellbeingScore.link',
        },
      ],
    },
    {
      label: 'navigation.first.rest',
      children: [
        {
          label: 'navigation.first.solutions.label',
          link: 'navigation.first.solutions.link',
        },
        {
          label: 'navigation.first.partners.label',
          link: 'navigation.first.partners.link',
        },
        {
          label: 'navigation.first.investors.label',
          link: 'navigation.first.investors.link',
        },
        {
          label: 'navigation.first.articles.label',
          link: 'navigation.first.articles.link',
        },
        {
          label: 'navigation.first.privacy.label',
          link: 'navigation.first.privacy.link',
          external: false,
        },
        {
          label: 'navigation.first.accessibility.label',
          link: 'navigation.first.accessibility.link',
        },
        {
          label: 'navigation.first.oneKeycloakUserGuide.label',
          link: 'navigation.first.oneKeycloakUserGuide.link',
        },
        {
          label: 'navigation.first.internationalVisits.label',
          link: 'navigation.first.internationalVisits.link',
          external: true,
        },
        {
          label: 'navigation.first.cookies.label',
          link: 'navigation.first.cookies.link',
        },
        {
          label: 'navigation.first.cookiesSetting.label',
          fn: () => {
            if (!isSameLanguage(locale.value)) {
              setDidomiLanguage(locale.value)
              refresh()
              window.setTimeout(() => show(), 250)
            } else {
              show()
            }
          },
        },
        {
          label: 'navigation.first.surveillance.label',
          link: 'navigation.first.surveillance.link',
        },
        {
          label: 'navigation.first.merge.label',
          link: 'navigation.first.merge.link',
        },
      ],
    },
  ]

  return {
    footerData,
  }
}
